/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Add_To_WundoInputs */



/**
* | output |
* | --- |
* | "Add Wundo" |
*
* @param {Meeting_Add_To_WundoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_add_to_wundo = /** @type {((inputs?: Meeting_Add_To_WundoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Add_To_WundoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter Wundo")
	return /** @type {LocalizedString} */ ("Add Wundo")
});